import { authSetupAxiosInstance } from '../../axios/authSetupAxios';
import { beSetupAxiosInstance } from '../../axios/beSetupAxios';
import { experianServiceAxiosInstance } from '../../axios/experianServiceAxios';
import { ApplicationStatusEnum } from '../../enum/applicationStepStatus';
import { APPLICATION_TYPE } from '../../enum/applicationType';

const getIslamicApplications = async (requestData: any) => {
  const params = {
    filters: requestData.filters,
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getSubmitForApprovalIslamicApplication = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.SUBMITTED_FOR_APPROVAL,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/application/submit-for-approval`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getPendingIslamicApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.PENDING,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };

  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getReferbackIslamicApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.REFERBACK,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getFollowUpIslamicApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.FOLLOWED_UP,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getReferbackFromPendingDisbursementIslamicApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.REFERBACK_FROM_PENDING_DISBURSEMENT,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getApprovedIslamicApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.APPROVED,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getRejectedIslamicApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.REJECTED,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getCancelledIslamicApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.CANCELED,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getDraftIslamicApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationStatus: ApplicationStatusEnum.DRAFT,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/admin/api/v1.0/applications`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicApplicationDetails = async (requestData: any) => {
  const { applicationId } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const getIslamicInternalRemarksByApplicationID = async (requestData: any) => {
  const { adminId, filters } = requestData;
  const params = { filters: requestData.filters };
  const url = `/redCash/admin/api/v1.0/internalRemark/application/${filters.applicationId}`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicHistoryLogsByApplicationID = async (requestData: any) => {
  const { applicationId } = requestData;
  const params = {
    sortField: 'createdAt',
    sortOrder: 'desc',
  };
  const url = `/redCash/admin/api/v1.0/historyLog/application/${applicationId}`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const getIslamicHistoryLogsByApplicationIDAndAgreementID = async (requestData: any) => {
  const { applicationId, agreementId } = requestData;
  const params = {
    sortField: 'createdAt',
    sortOrder: 'desc',
  };
  const url = `/redCash/admin/api/v1.0/historyLog/application/${applicationId}/agreement/${agreementId}`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const createIslamicInternalRemark = async (requestData: any) => {
  const url = `/redCash/admin/api/v1.0/internalRemark`;
  const res = await beSetupAxiosInstance.post(url, {
    ...requestData,
    username: localStorage.getItem('username'),
  });
  return res.data;
};

const referBackIslamicApplication = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/status/referBack`;

  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const cancelIslamicApplication = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/status/cancel`;

  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const referBackIslamicApplicationFromPendingDisbursement = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/status/refer-back-from-pending-disbursement`;

  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const submitForIslamicApproval = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/status/submittedForApproval`;
  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const approveIslamicApplication = async (requestData: any) => {
  const { applicationId, language, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/${language}/status/approved`;
  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const rejectIslamicApplication = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/status/rejected`;
  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const deleteIslamicApplication = async (requestData: any) => {
  const { applicationId } = requestData;
  const url = `/redCash/api/v1.0/application/${applicationId}`;

  const res = await beSetupAxiosInstance.delete(url);
  return res.data;
};

const getIslamicApplicationCreditRecord = async (requestData: any) => {
  const { applicationId } = requestData;
  const url = `/redCash/admin/api/v1.0/creditRecord/application/${applicationId}`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const updateIslamicApplicationFinanceAmount = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/api/v1.0/application/update-finance-amount/id/${applicationId}`;
  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const updateIslamicApplicant = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/user`;
  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const updateIslamicApplicationNetIncome = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/patchNetIncome`;
  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const updateIslamicApplicationStatusToFollowedUp = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/status/followed-up`;
  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const updateIslamicApplicationStatusToCaseSettledFromFollowedUp = async (requestData: any) => {
  const { applicationId, payload } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/status/settled-from-followed-up`;
  const res = await beSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const updateIslamicApplicantUserDetails = async (requestData: any) => {
  const { userId, payload, applicationId, agreementId } = requestData;
  const url = `/redCash/admin/auth/api/v1.0/user/${userId}/applicationId/${applicationId}/agreementId/${agreementId}`;

  const res = await authSetupAxiosInstance.patch(url, payload);
  return res.data;
};

const islamicGlobalSearch = async (requestData: any) => {
  const { payload } = requestData;
  const params = {
    currentPage: requestData.params?.pagination.current,
    pageSize: requestData.params?.pagination.pageSize,
    filters: {
      ...requestData.filters,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
  };
  const url = `/redCash/admin/api/v1.0/application/global-search`;
  const res = await beSetupAxiosInstance.post(url, payload, { params });
  return res.data;
};

const getIslamicApplicationExperianReport = async (requestData: any) => {
  const { fileId, newIc, params } = requestData;
  const url = `redCash/api/v1.0/experian/xmlToHtml/fileId/${fileId}/newIc/${newIc}`;
  const res = await experianServiceAxiosInstance.get(url, { params });
  return res.data;
};

const regenerateIslamicApplicationForm = async (requestData: any) => {
  const { applicationId } = requestData;
  const url = `redCash/api/v1.0/regenerateApplicationForm/${applicationId}`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const reRunIslamicApplicationCreditEvaluationEngine = async (requestData: any) => {
  const { applicationId, isNewApplication } = requestData;
  const url = `/redCash/admin/api/v1.0/application/${applicationId}/rerun-engine/isNewApplication/${isNewApplication}`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const getIslamicFinoryEmbeddedUrl = async (applicationId: string) => {
  const url = `/redCash/api/v1.0/application/${applicationId}/finory`;
  const res = await beSetupAxiosInstance.get(url);
  return res.data;
};

const getIslamicApprovedReviewApplications = async (requestData: any) => {
  const params = {
    filters: {
      ...requestData.filters,
      applicationType: APPLICATION_TYPE.ISLAMIC,
    },
    search: requestData.search,
    sortField: requestData.sortField,
    sortOrder: requestData.sortOrder,
    currentPage: requestData.pagination.current,
    pageSize: requestData.pagination.pageSize,
  };
  const url = `/redCash/api/v1.0/application/approved-review`;
  const res = await beSetupAxiosInstance.get(url, { params });
  return res.data;
};

const islamicApplicationService = {
  getIslamicApplications,
  getPendingIslamicApplications,
  getReferbackIslamicApplications,
  getFollowUpIslamicApplications,
  getApprovedIslamicApplications,
  getRejectedIslamicApplications,
  getCancelledIslamicApplications,
  getDraftIslamicApplications,
  getIslamicApplicationDetails,
  getIslamicInternalRemarksByApplicationID,
  getIslamicHistoryLogsByApplicationID,
  createIslamicInternalRemark,
  referBackIslamicApplication,
  cancelIslamicApplication,
  submitForIslamicApproval,
  approveIslamicApplication,
  rejectIslamicApplication,
  deleteIslamicApplication,
  getIslamicHistoryLogsByApplicationIDAndAgreementID,
  getIslamicApplicationCreditRecord,
  updateIslamicApplicationFinanceAmount,
  updateIslamicApplicant,
  updateIslamicApplicationNetIncome,
  updateIslamicApplicationStatusToFollowedUp,
  updateIslamicApplicationStatusToCaseSettledFromFollowedUp,
  updateIslamicApplicantUserDetails,
  islamicGlobalSearch,
  referBackIslamicApplicationFromPendingDisbursement,
  getIslamicApplicationExperianReport,
  getReferbackFromPendingDisbursementIslamicApplications,
  getSubmitForApprovalIslamicApplication,
  regenerateIslamicApplicationForm,
  reRunIslamicApplicationCreditEvaluationEngine,
  getIslamicFinoryEmbeddedUrl,
  getIslamicApprovedReviewApplications,
};

export default islamicApplicationService;
